import { Button, styled } from '@mui/material'

const TextBotton = styled('div')(({ theme }) => ({
  fontFamily: theme.typography.fontFamily,
  fontStyle: 'normal',
  fontWeight: 600,
  fontSize: '13px',
  lineHeight: '12px',
  textAlign: 'center',
}))

const BottomCustom = ({
  text,
  onClick,
  startIcon,
  styleText,
  styleButton,
  variant = 'outlined',
  size = 'medium',
  disabled = false,
  ...rest
}) => {
  const computedStyles =
    typeof styleButton === 'function'
      ? theme => styleButton(theme, { disabled })
      : styleButton

  return (
    <Button
      size={size}
      onClick={onClick}
      startIcon={startIcon}
      variant={variant}
      disabled={disabled}
      sx={computedStyles}
      {...rest}>
      <TextBotton sx={styleText}>{text}</TextBotton>
    </Button>
  )
}

export default BottomCustom
